
import { disabledUiActionTypes } from '../../constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = {
    allInputsDisabled: false,
    buttonsDisabled: [],
    errorMessage: null,
    errorMessageReplacements: []
};

export default (state = INITIAL_STATE, action = {}) => {
    switch(action.type) {
        case disabledUiActionTypes.UPDATE_DISABLED_UI:
            return action.disabledUi;

        case disabledUiActionTypes.CLEAR_DISABLED_UI:
        case disabledUiActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;

        default:
            return state;
    }
};